import { getApi } from "./util/getApi";

const fetchURL = process.env.REACT_APP_API_URL + "/auth";

const api = getApi(fetchURL);

export const registerUser = (data: {
  Email: string;
  Name: string;
  Password: string;
}) => api.post("/registerUser", data).then((r) => r.data);

export const loginUser = (data: { Email_address: string; Password: string }) =>
  api
    .post("/loginUser", { ...data, loginAs: "organization" })
    .then((r) => r.data);

export const verifyResetPassword = (data: {
  token: string;
  email: string;
  New_password: string;
}) => api.post("/verifyResetPassword", data).then((r) => r.data);

export const loginOrganization = async (organizationId: number) => {
  const res = await api.post("/orgLogin", { organization_id: organizationId });
  return res.data;
};
